
import Vue from 'vue';

export default Vue.extend({
  name: 'ChefRequested',
  head: {
    title: 'Aanvraag bevestiging - CHEFSTBL',
  },
})
